import { api } from "@/lib/api";

export function openRazorpay(data, { onSuccess, onFailure }) {
  if (!window.Razorpay) {
    onFailure?.(false);
    return;
  }
  const rzp = new window.Razorpay({
    key: data.key_id,
    amount: data.amount,
    currency: data.currency,
    name: data.name || "Just be you",
    description: data.description || "",
    order_id: data.order_id,
    prefill: { email: data.prefill_email || "" },
    theme: { color: "#284b63" },
    handler: async (resp) => {
      try {
        await api.post("/checkout/verify", resp);
        onSuccess(data.order_id);
      } catch {
        onFailure?.(false);
      }
    },
    modal: { ondismiss: () => onFailure?.(true) },
  });
  rzp.on("payment.failed", () => onFailure?.(false));
  rzp.open();
}
